<template>
  <v-container :class="[dense ? 'px-0' : 'px-4']">
    <slot />
  </v-container>
</template>

<script>
export default {
  name: 'Container',
  props: {
    dense: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: map-get($grid-breakpoints, 'xl');

  &--sm {
    max-width: map-get($grid-breakpoints, 'sm') !important;
  }
  &--md {
    max-width: map-get($grid-breakpoints, 'md') !important;
  }
  &--lg {
    max-width: map-get($grid-breakpoints, 'lg') !important;
  }
  &--full {
    max-width: 100%;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
</style>
